import { DAY_TOOLS, TOTAL_STEPS, stepIndex, type LessonDay } from '@gc/shared';
import { haptic } from '../lib/telegram.js';

export interface LessonCardProps {
  day: LessonDay;
  done: boolean;
  busy?: boolean;
  onToggle: (day: number, done: boolean) => void;
  onTool: (kind: string, id: string) => void;
}

const TYPE_LABEL: Record<string, string> = {
  lesson: 'Занятие',
  concert: 'Концерт',
  review: 'Итоги',
};

export function LessonCard({ day, done, busy, onToggle, onTool }: LessonCardProps): JSX.Element {
  const tools = DAY_TOOLS[day.day] ?? [];

  return (
    <article className={`card lesson ${done ? 'done' : ''}`}>
      <header className="lesson-top">
        <span className="daynum">День {day.day}</span>
        <span className="mono dim">
          {TYPE_LABEL[day.type]} {stepIndex(day.day)}/{TOTAL_STEPS} · {day.duration_min} мин
        </span>
      </header>

      <h2>{day.title}</h2>
      <p className="goal">{day.goal}</p>

      <ol className="blocks">
        {day.blocks.map((b, i) => (
          <li key={i}>
            <span className="mono t">{b.min} мин</span>
            <span>
              <b>{b.name}.</b> {b.text}
            </span>
          </li>
        ))}
      </ol>

      <dl className="notes">
        <dt>Проверка</dt>
        <dd>{day.check}</dd>
        <dt>Родителю</dt>
        <dd>{day.parent}</dd>
        {day.fun ? (
          <>
            <dt>Бонус</dt>
            <dd>{day.fun}</dd>
          </>
        ) : null}
      </dl>

      {tools.length > 0 && (
        <div className="chips">
          {tools.map((t) => (
            <button
              key={`${t.kind}_${t.id}`}
              type="button"
              className="chip ghost"
              onClick={() => {
                haptic.tap();
                onTool(t.kind, t.id);
              }}
            >
              🎧 {t.label}
            </button>
          ))}
        </div>
      )}

      <button
        type="button"
        className={`btn wide ${done ? 'secondary' : ''}`}
        disabled={busy}
        onClick={() => {
          haptic.done();
          onToggle(day.day, !done);
        }}
      >
        {done ? '↩️ Снять отметку' : '✅ Выполнено'}
      </button>
    </article>
  );
}
